import m from 'mithril'

export default {
  view: vnode => {
    const image = require('./image25.jpg')

    return (
      <div className={`log-book-page-content-inner log-book-page-template mod-07-page`}>
        <div className={`log-book-text-container ${vnode.attrs.unredacted ? 'is-unredacted' : 'is-redacted'}`}>
          <figure className="log-book-figure">
            <img src={image} className="log-book-img" />
            <figcaption className="log-book-figcaption">
              Den amerikanske hærs kort over perioder med lys og mørke ved Camp Century.
            </figcaption>
          </figure>

          <p className="log-book-text">Fra 18. november til 27. januar: Mørkt hele døgnet</p>
          <p className="log-book-text">Fra 7. april til 15. september: Lyst hele døgnet</p>

          <h3 className="log-book-text mod-h3">
            Livet i Camp Century er så hårdt, at soldaterne får ekstra mængder mad.
          </h3>
          <p className="log-book-text">
            Menu til ‘isorme’.
          </p>
          <p className="log-book-text">
          Breakfast: Tumblers of tomato or orange juice, fried eggs and bacon, hot cakes with syrup, hot biscuits with butter, bread with jam or jelly plus two mugs of hot strong coffee.
          </p>
          <p className="log-book-text">
          Lunch: Two huge hamburgers, macaroni and cheese, creamed corn, bread and butter, lettuce salad with Russian dressing, pickles, carrots and olives, sliced peaches, lemonade cooled by chunks of glacial ice, milk and coffee. 
          </p>
          <p className="log-book-text">
          Dinner: Steaks, mashed potatoes and gravy, peas, stewed tomatoes, lettuce salad, hot biscuits with butter, ginger cake, sliced pineapple, fresh oranges and apples, grape juice chilled by cubes of ice cap, and coffee.  
          </p>
          <p className="log-book-text">
          Midnight snack: Thick chunks of ham with scrambled eggs, jumbo hamburgers.  
          </p>
        </div>
      </div>
    )
  }
}
